import { createAction } from '@reduxjs/toolkit';
import {
	LiftStation,
	LiftStationFormFields,
	ListStationsParams,
	PaginatedSensorGroupsFromStation,
	PaginatedSensorsFromStation,
	PaginatedStations,
} from '@Types/stations.types';
import { addNamespace } from '@Utils/actions';

export const clearStations = createAction(addNamespace('liftStations/clear'));

export const getStations = createAction<ListStationsParams>(
	addNamespace('liftStations/getLiftStations/all'),
);
export const getStationsResolved = createAction<PaginatedStations | undefined>(
	addNamespace('liftStations/getLiftStations/all/resolved'),
);
export const getStationsRejected = createAction(
	addNamespace('liftStations/getLiftStations/all/rejected'),
);

export const getFirstLocationFromSensors = createAction<string[]>(
	addNamespace('sensors/getFirstLocationFromSensors'),
);
export const getFirstLocationFromSensorsResolved = createAction<
	[number, number]
>(addNamespace('sensors/getFirstLocationFromSensors/resolved'));
export const getFirstLocationFromSensorsRejected = createAction(
	addNamespace('sensors/getFirstLocationFromSensors/rejected'),
);

export const upsertLiftStation = createAction<LiftStationFormFields>(
	addNamespace('liftStations/upsertLiftStation'),
);
export const upsertLiftStationResolved = createAction(
	addNamespace('liftStations/upsertLiftStation/resolved'),
);
export const upsertLiftStationRejected = createAction(
	addNamespace('liftStations/upsertLiftStation/rejected'),
);

export const getSingleStationById = createAction<string>(
	addNamespace('liftStations/getSingleStationById'),
);
export const getSingleStationByIdResolved = createAction<LiftStation>(
	addNamespace('liftStations/getSingleStationById/resolved'),
);
export const getSingleStationByIdRejected = createAction(
	addNamespace('liftStations/getSingleStationById/rejected'),
);

export const getSensorsFromStation = createAction<string>(
	addNamespace('liftStations/getSensorsFromStation'),
);
export const getSensorsFromStationResolved =
	createAction<PaginatedSensorsFromStation>(
		addNamespace('liftStations/getSensorsFromStation/resolved'),
	);
export const getSensorsFromStationRejected = createAction(
	addNamespace('liftStations/getSensorsFromStation/rejected'),
);

export const getSensorGroupsFromStation = createAction<string>(
	addNamespace('liftStations/getSensorGroupsFromStation'),
);
export const getSensorGroupsFromStationResolved =
	createAction<PaginatedSensorGroupsFromStation>(
		addNamespace('liftStations/getSensorGroupsFromStation/resolved'),
	);
export const getSensorGroupsFromStationRejected = createAction(
	addNamespace('liftStations/getSensorGroupsFromStation/rejected'),
);

export const getImagesFromStation = createAction<string>(
	addNamespace('liftStations/getImagesFromStation'),
);
export const getImagesFromStationResolved = createAction<string[]>(
	addNamespace('liftStations/getImagesFromStation/resolved'),
);
export const getImagesFromStationRejected = createAction(
	addNamespace('liftStations/getImagesFromStation/rejected'),
);

export const deleteLiftStation = createAction<string>(
	addNamespace('liftStations/liftStations/delete'),
);
export const deleteLiftStationResolved = createAction(
	addNamespace('liftStations/liftStations/delete/resolved'),
);
export const deleteLiftStationRejected = createAction(
	addNamespace('liftStations/liftStations/delete/rejected'),
);
